import React from 'react';
import SafetyTruckContents from '../../../component/Safety/Truck/SafetyTruckContents';

const Truck = () => {
  return <SafetyTruckContents />;
};

export default Truck;
